import { render, staticRenderFns } from "./gj-card.vue?vue&type=template&id=3b675d91&scoped=true&"
import script from "./gj-card.vue?vue&type=script&lang=js&"
export * from "./gj-card.vue?vue&type=script&lang=js&"
import style0 from "./gj-card.vue?vue&type=style&index=0&id=3b675d91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b675d91",
  null
  
)

export default component.exports